import { render } from "./downloadImg.vue?vue&type=template&id=3345b440&scoped=true"
import script from "./downloadImg.vue?vue&type=script&lang=js"
export * from "./downloadImg.vue?vue&type=script&lang=js"

import "./downloadImg.vue?vue&type=style&index=0&id=3345b440&lang=css"
import "./downloadImg.vue?vue&type=style&index=1&id=3345b440&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3345b440"]])

export default __exports__